// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-h_fJ","catalogByServiceItem__title":"c-h_fK"};